import { AnimatePresence } from 'framer-motion';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import Spinner from '../../../components/common/Spinner';
import { wallets } from '../../../helpers/helperFunctions';
import { WalletsType } from '../../../types/types';
import { PurchaseSteps } from './PurchaseSteps';
import { purchaseBigWhaleVoucher } from '../Portfolio.actions';

import { PayMixed } from './PayMixed';
import { PayTether } from './PayTether';
import { PaymentMethod } from './PaymentMethod';
import { Success } from './Success';

interface PurchaseVoucherProps {
  selectedPackage: any;
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  userDiscountCodeId?: number | null;
}

export const PurchaseVoucher = ({
  selectedPackage,
  setModal,
  modal,
  userDiscountCodeId = null
}: PurchaseVoucherProps) => {
  const dispatch = useAppDispatch();
  const { loadingVoucher } = useAppSelector((state) => state.portfolio);

  const [step, setStep] = useState<PurchaseSteps>(PurchaseSteps.PAYMENT_METHOD);
  const [selectedLicence, setSelectedLicence] = useState<any>(null);
  const [selectedNetwork, setSelectedNetwork] = useState<WalletsType>(
    wallets[0]
  );
  const [selectedToken, setSelectedToken] = useState<any>();

  const [lp, setLp] = useState('');
  const [club, setClub] = useState('');
  const [usdt, setUsdt] = useState('');
  const [usdc, setUsdc] = useState('');
  const [cash, setCash] = useState('');

  const renderTitle = handleSidebarTitle(step);

  useEffect(() => {
    setLp('');
    setCash('');
    setClub('');
    setUsdt('');
    setUsdc('');
    setSelectedToken('');
  }, [modal]);

  const handlePay = () => {
    dispatch(
      purchaseBigWhaleVoucher({
        packageId: selectedPackage.id,
        lp: Number(lp),
        club: Number(club),
        cash: Number(cash),
        usdt: Number(usdt),
        usdc: Number(usdc),
        networkType: selectedNetwork.networkType,
        handleSuccess: () => setStep(PurchaseSteps.SUCCESS)
      })
    );
  };

  return (
    <SidebarModal
      isOpen={modal}
      sidebarWidth={'600px'}
      setOpen={(v) => {
        setModal(v);
        setStep(PurchaseSteps.PAYMENT_METHOD);
      }}
      title={renderTitle}>
      <AnimatePresence exitBeforeEnter>
        {loadingVoucher && <Spinner absolute transparent />}

        {step === PurchaseSteps.PAYMENT_METHOD && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_METHOD}>
            <PaymentMethod
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              setUsdt={setUsdt}
              userDiscountCodeId={userDiscountCodeId}
            />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.PAY_MIXED && (
          <AnimatedTab key={PurchaseSteps.PAY_MIXED}>
            <PayMixed
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              lp={lp}
              club={club}
              usdt={usdt}
              cash={cash}
              setLp={setLp}
              setClub={setClub}
              setUsdt={setUsdt}
              setCash={setCash}
              handlePay={handlePay}
            />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.PAY_TETHER && (
          <AnimatedTab key={PurchaseSteps.PAY_TETHER}>
            <PayTether
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              selectedNetwork={selectedNetwork}
              setSelectedNetwork={setSelectedNetwork}
              setSelectedToken={setSelectedToken}
              selectedToken={selectedToken}
              setUsdc={setUsdc}
              setUsdt={setUsdt}
              lp={lp}
              club={club}
              usdt={usdt}
              usdc={usdc}
              cash={cash}
              handlePay={handlePay}
            />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.SUCCESS && (
          <AnimatedTab key={PurchaseSteps.SUCCESS}>
            <Success
              selectedPackage={selectedPackage}
              usdt={usdt}
              selectedLicence={selectedLicence}
              userDiscountCodeId={userDiscountCodeId}
            />
          </AnimatedTab>
        )}
      </AnimatePresence>
    </SidebarModal>
  );
};

const handleSidebarTitle = (step: PurchaseSteps) => {
  const { t } = useTranslation('marketplace');

  switch (step) {
    case PurchaseSteps.PAYMENT_METHOD:
      return 'SELECT VOUCHER';
    case PurchaseSteps.PAY_MIXED:
      return 'SELECT VOUCHER';
    case PurchaseSteps.PAY_TETHER:
      return 'SELECT VOUCHER';
    case PurchaseSteps.SUCCESS:
      return t('order_confirmation');

    default:
      return '';
  }
};
